import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionmarkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 82,
	height: 83,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#FFCD3F",
		fillRule: "evenodd",
		d: "M41 8.3A33 33 0 0 0 8.2 41.5 33 33 0 0 0 41 74.7a33 33 0 0 0 32.8-33.2A33 33 0 0 0 41 8.3ZM0 41.5C0 18.5 18.4 0 41 0s41 18.6 41 41.5S63.6 83 41 83 0 64.4 0 41.5Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#FFCD3F",
		d: "M38.6 25.8a5 5 0 0 1 7.2.7 5.2 5.2 0 0 1-1 7.5l-3.5 2.6a11 11 0 0 0-4.4 8.8v2.8h8.2v-2.8c0-2.2 3-3.6 4.6-4.7A13.6 13.6 0 0 0 52 21.2c-4.7-5.7-13-6.5-18.7-1.8L28 24l5.2 6.5 5.4-4.6Zm7.5 33.4c0 2.8-2.3 5.2-5.1 5.2s-5.1-2.4-5.1-5.2S38.2 54 41 54s5.1 2.3 5.1 5.2Z"
	})]
});
export default SvgQuestionmarkIcon;
